import { render } from "./teaAgePieEcharts.vue?vue&type=template&id=807e47c6&scoped=true"
import script from "./teaAgePieEcharts.vue?vue&type=script&lang=js"
export * from "./teaAgePieEcharts.vue?vue&type=script&lang=js"

import "./teaAgePieEcharts.vue?vue&type=style&index=0&id=807e47c6&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-807e47c6"]])

export default __exports__